module.exports = __webpack_public_path__ + "images/unboxing_videos/cover_calendar-adcf9a59b75486d9f26cffb5d94ba09a.png";